import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "../../styles/legal-pages.css";
import "../../styles/inner-page.css";

const PrivacyPage = () => {
    return (
        <div className="page-wrapper inner-page-wrapper">
            <Header />
            <main className="legal-page">
                <div className="container-default w-container">
                    <div className="legal-header">
                        <div className="big-font-title display-2---size">Legal</div>
                        <h1 className="display-2">Privacy Policy</h1>
                        <p className="legal-updated">Last updated: January 2, 2026</p>
                    </div>

                    <div className="legal-content">
                        <section className="legal-section">
                            <h2>Introduction</h2>
                            <p>
                                Younivision ("we," "our," or "us") respects your privacy and is committed to 
                                protecting your personal data. This Privacy Policy explains how we collect, use, 
                                disclose, and safeguard your information when you visit our website or use our 
                                services.
                            </p>
                            <p>
                                Please read this Privacy Policy carefully. By accessing or using our Services, 
                                you acknowledge that you have read, understood, and agree to be bound by this 
                                Privacy Policy.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>Information We Collect</h2>
                            <h3>Personal Information</h3>
                            <p>We may collect personal information that you voluntarily provide, including:</p>
                            <ul>
                                <li>Name and contact information (email address, phone number)</li>
                                <li>Business information (company name, job title)</li>
                                <li>Project requirements and specifications</li>
                                <li>Payment and billing information</li>
                                <li>Communications and correspondence with us</li>
                            </ul>

                            <h3>Automatically Collected Information</h3>
                            <p>When you visit our website, we may automatically collect:</p>
                            <ul>
                                <li>IP address and device information</li>
                                <li>Browser type and version</li>
                                <li>Pages visited and time spent on pages</li>
                                <li>Referring website addresses</li>
                                <li>Geographic location (country/city level)</li>
                            </ul>
                        </section>

                        <section className="legal-section">
                            <h2>How We Use Your Information</h2>
                            <p>We use the information we collect to:</p>
                            <ul>
                                <li>Provide, maintain, and improve our Services</li>
                                <li>Process transactions and send related information</li>
                                <li>Respond to your inquiries and provide customer support</li>
                                <li>Send promotional communications (with your consent)</li>
                                <li>Analyze website usage and improve user experience</li>
                                <li>Detect and prevent fraud or security issues</li>
                                <li>Comply with legal obligations</li>
                            </ul>
                        </section>

                        <section className="legal-section">
                            <h2>Information Sharing</h2>
                            <p>We do not sell your personal information. We may share your information with:</p>
                            <ul>
                                <li><strong>Service Providers:</strong> Third parties who assist us in operating 
                                our business (e.g., hosting, payment processing, analytics)</li>
                                <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
                                <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, 
                                or sale of assets</li>
                                <li><strong>With Your Consent:</strong> When you have given us permission to share</li>
                            </ul>
                        </section>

                        <section className="legal-section">
                            <h2>Cookies and Tracking Technologies</h2>
                            <p>
                                We use cookies and similar tracking technologies to collect information about your 
                                browsing activities. Cookies are small text files stored on your device that help 
                                us improve your experience.
                            </p>
                            <p>Types of cookies we use:</p>
                            <ul>
                                <li><strong>Essential Cookies:</strong> Required for website functionality</li>
                                <li><strong>Analytics Cookies:</strong> Help us understand how visitors use our site</li>
                                <li><strong>Marketing Cookies:</strong> Used to deliver relevant advertisements</li>
                            </ul>
                            <p>
                                You can control cookies through your browser settings. However, disabling certain 
                                cookies may affect website functionality.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>Data Security</h2>
                            <p>
                                We implement appropriate technical and organizational security measures to protect 
                                your personal information against unauthorized access, alteration, disclosure, or 
                                destruction. However, no method of transmission over the Internet is 100% secure, 
                                and we cannot guarantee absolute security.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>Data Retention</h2>
                            <p>
                                We retain your personal information for as long as necessary to fulfill the purposes 
                                outlined in this Privacy Policy, unless a longer retention period is required by law. 
                                Project-related data may be retained for up to 7 years for legal and business purposes.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>Your Rights</h2>
                            <p>Depending on your location, you may have the right to:</p>
                            <ul>
                                <li>Access the personal information we hold about you</li>
                                <li>Request correction of inaccurate information</li>
                                <li>Request deletion of your personal information</li>
                                <li>Object to or restrict processing of your information</li>
                                <li>Request data portability</li>
                                <li>Withdraw consent at any time</li>
                            </ul>
                            <p>
                                To exercise these rights, please contact us using the information provided below.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>Children's Privacy</h2>
                            <p>
                                Our Services are not intended for individuals under the age of 18. We do not 
                                knowingly collect personal information from children. If you believe we have 
                                collected information from a child, please contact us immediately.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>Third-Party Links</h2>
                            <p>
                                Our website may contain links to third-party websites. We are not responsible for 
                                the privacy practices or content of these sites. We encourage you to review the 
                                privacy policies of any third-party sites you visit.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>Changes to This Policy</h2>
                            <p>
                                We may update this Privacy Policy from time to time. We will notify you of any 
                                changes by posting the new Privacy Policy on this page and updating the "Last 
                                updated" date. We encourage you to review this Privacy Policy periodically.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>Contact Us</h2>
                            <p>
                                If you have questions or concerns about this Privacy Policy or our data practices, 
                                please contact us at:
                            </p>
                            <p>
                                <strong>Younivision</strong><br />
                                Email: <a href="mailto:hello@younivision.com">hello@younivision.com</a><br />
                                Website: <a href="https://younivision.com">younivision.com</a>
                            </p>
                        </section>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default PrivacyPage;

